export default {
  DUVAL_TRIANGLE_1: 'duval-triangle-1',
  DUVAL_TRIANGLE_4: 'duval-triangle-4',
  DUVAL_TRIANGLE_5: 'duval-triangle-5',
  DUVAL_PENTAGON_1: 'duval-pentagon-1',
  DUVAL_PENTAGON_2: 'duval-pentagon-2',
  GASES_RATIO_C2H2_C2H4_CH4_H2: 'gases-ratio-c2h2-c2h4-ch4-h2',
  GASES_RATIO_C2H2_C2H4_C2H4_C2H6: 'gases-ratio-c2h2-c2h4-c2h4-c2h6',
};
